<template>
  <div>
    <div class="page-title">
      <custom-breadcrumb/>
    </div>

    <!-- 按钮区域 -->
    <div class="search-area">
      <div class="left">
        <el-input placeholder="Filter Files" v-model="searchForm['fileName']" class="input-with-select"
                  style="width: 550px;">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <div class="search-button" slot="append" @click="search">
            Search
          </div>
        </el-input>
        <el-button icon="el-icon-sort"
                   :icon="clieckedSort==''?'el-icon-sort':(searchForm['sort']?'el-icon-sort-up':'el-icon-sort-down')"
                   @click="searchForm['sort']=!searchForm['sort'];clieckedSort=1">Sort
        </el-button>
      </div>
      <div class="btn" @click="visible=true">Upload files</div>
    </div>
    <!-- 内容区域（无内容） -->
    <div v-if="!existsData" class="no-content">
      <p><img src="https://master-shopvidi.s3.amazonaws.com/upload-detail.png"></p>
      <p>Upload and manage your files</p>
      <p>Files can be images(jpg/png/gif)</p>
      <div>
        <div class="btn" @click="visible=true">Upload files</div>
      </div>
    </div>
    <!-- 内容区域（有内容） -->
    <div v-else>
      <el-table
        :data="tableData"
        height="calc(100vh - 276px)"
        stripe
        style="width: 100%;"
      >
        <el-table-column label="File Name" min-width="300">
          <template slot-scope="scope">
            <div class="table-name">
              <div class="table-img"><img :src="scope.row['link']" alt=""></div>
              <div>
                {{ scope.row['pname'] }}
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          label="Date added"
          prop="createdAt"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="size"
          min-width="100"
          label="Size"
        >
        </el-table-column>

        <el-table-column
          label="Link"
        >
          <template slot-scope="scope">
            <el-button icon="el-icon-paperclip" @click="copyLink($event,scope.row)" round>Copy</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :currentPage="searchForm.currentPage"
        :total="searchForm.total"
        :pageSize="searchForm.pageSize"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />

    </div>

    <el-dialog
      width="700px"
      :show-close="true"
      :visible.sync="visible"
      destroy-on-close
      @close="closeDia"
      :close-on-click-modal="false"
    >
      <el-upload
        drag
        class="upload-area"
        :limit="15"
        :headers="headers"
        accept=".jpg,.png,.gif"
        :file-list="fileList"
        :action="uploadApi"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :before-remove="beforeRemove"
        multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Drag files here, or<em> click Upload</em></div>
        <div class="el-upload__tip" slot="tip">
          The image format supports jpg/png/gif, <3M, up to 15 can be uploaded.
        </div>
      </el-upload>

    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import {getAction, putAction} from '@/api/manage.js'
import {handleClipboard} from '@/utils/copy'
import Pagination from '../components/pagination.vue'
import qs from 'qs'
import CustomBreadcrumb from '../components/custom-breadcrumb'

export default {
  components: {CustomBreadcrumb, Pagination},
  data() {
    return {
      existsData: false,
      visible: false,
      searchForm: {
        pageSize: 15,
        currentPage: 1,
        total: 1,
        sort: false
      },
      headers: {
        'x-access-token': Vue.ls.get('token')
      },
      tableData: [],
      paging: {},
      fileList: [],
      clieckedSort: '',
      uploadApi: process.env.API_URL + 'v0.2/product/picture_libraries'

    }
  },
  created() {
    this.search()
  },
  watch: {
    searchForm: {
      handler(n, o) {
        this.search()
      },
      deep: true
    }
  },
  methods: {
    async search() {
      let res = await getAction(`/v0.2/product/picture_libraries?${qs.stringify(this.searchForm)}`)
      if (res['success']) {
        this.searchForm.total = res['result'].total
        this.searchForm.currentPage = res['result'].current
        this.searchForm.pageSize = res['result'].size

        this.tableData = res['result']['records']
        if (this.tableData && this.tableData.length > 0) {
          this.existsData = true
        }
      } else {
        this.visible = false
        this.$message.error(res['message'])
      }
    },
    closeDia() {
      this.searchForm['sort'] = false
      this.search()
    },

    copyLink(e, row) {
      handleClipboard(row['link'], e)
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.searchForm.currentPage = 1
      this.search()
    },
    handleCurrentChange(val) {
      this.searchForm.currentPage = val
      this.search()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    },
    beforeRemove(e) {
      return false
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      this.$message.warning(`Please upload pictures according to the requirements`)
    }

  }

}
</script>

<style scoped lang="less">
.page-title{
  margin: 10px 30px 20px 0px !important;
}
/deep/ .el-button--default:focus,
.el-button--default:active,
.el-button--default:hover {
  background-color: #fff !important;
  color: #606266 !important;
  border-color: #606266;
}

/deep/ .el-input-group__append {
  background: #000000;
  color: #ffffff;

  :hover {
    cursor: pointer;
  }
}

.search-area {
  margin: 20px 0;
  display: flex;
  justify-content: space-around;

  .left {
    width: 100%;
  }

  .search-button {
    cursor: pointer;
  }
}

.btn {
  background: #000000;
  color: #ffffff;
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}

.table-name {
  display: flex;

  div:nth-child(2) {
    padding-left: 10px;
  }

  .table-img {
    max-width: 80px;
    max-height: 80px;
    border: 1px solid #262B2F;

    img {
      width: 100%;
      height: 100%;
    }

  }
}

.no-content {
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;

  img {
    width: 180px;
    height: 180px;
    margin-top: 10px;
  }

  p:nth-child(2) {
    font-family: Satoshi-Bold;
    margin: 15px 0;
  }

  div {
    margin: 30px auto;
  }
}

.upload-area {
  padding: 50px 30px 30px;
  margin: 0 auto;
  text-align: center;

  p {
    color: #FB541C;
    margin: 20px 0px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/produts/images-list.vue